export default "__VITE_ASSET__CfNU8gtx__"